// extracted by mini-css-extract-plugin
module.exports = {"SMenuWrapper":"Menu_SMenuWrapper__ELo7T","SLogoLink":"Menu_SLogoLink__kaYBb"};